module.exports = "/static/assets/060ba568c5b2e96a7fc4d7a9209e79d3.png";